<span class="toolbar-button">
  <button role="link" class="button" fxHide fxShow.gt-sm mat-button fxFlex="grow" (click)="clickGoToReleaseNotes()"
    aria-label="Open release notes" [matTooltip]="LangTextData.tooltipLabel.toolBoxReleaseNotes" matTooltipClass="table_tooltip_job_filename"
    matTooltipPosition="below">
    <mat-icon aria-hidden="true">new_releases</mat-icon>
  </button>
</span>